'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = widgetUi;

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _WidgetUi = require('conversations-schema/records/WidgetUi');

var _WidgetUi2 = _interopRequireDefault(_WidgetUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var TOGGLE_OPEN = ActionTypes.TOGGLE_OPEN,
    RECEIVED_WIDGET_SHELL_DATA = ActionTypes.RECEIVED_WIDGET_SHELL_DATA;


var parseShellData = function parseShellData(data) {
  return (0, _WidgetUi2.default)({
    mobile: '' + data.mobile === 'true',
    open: '' + data.open === 'true',
    hideWelcomeMessage: '' + data.hideWelcomeMessage === 'true',
    domain: data.domain,
    url: decodeURIComponent(data.url)
  });
};

function widgetUi() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _WidgetUi2.default)();
  var action = arguments[1];

  switch (action.type) {
    case RECEIVED_WIDGET_SHELL_DATA:
      return state.merge(parseShellData(action.payload));
    case TOGGLE_OPEN:
      return state.set('open', action.payload.isOpened);
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/widgetUi.js
// module id = 860
// module chunks = 2 3